module.exports = __webpack_public_path__ + "np.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/np.svg
// module id = 738
// module chunks = 0